import React, { FC, useMemo, useState } from "react"
import { Title, Button, ModalPanel, ExclusiveChoiceDropdown } from "dash-styled"
import { AIModel } from "../../../../../../../../Models/API/AIModel"

interface AddAITrainingTemplateModalProps {
    modelChoices: AIModel[]
    isProcessing: boolean
    onClose: () => void
    onSubmit: (model: AIModel) => void
}

export const AddAITrainingTemplateModal: FC<AddAITrainingTemplateModalProps> =
    ({ modelChoices, isProcessing, onClose, onSubmit }) => {
        const [selectedModelIndex, setSelectedModelIndex] = useState<number>(-1)
        const choices = useMemo(
            () => modelChoices.map(model => model.name),
            [modelChoices]
        )

        const selectedModel = modelChoices[selectedModelIndex]

        const handleSubmit = useMemo(() => {
            if (
                selectedModel === undefined ||
                selectedModel.root_id === undefined ||
                selectedModel.root_id === null
            ) {
                return undefined
            }

            return () => {
                onSubmit(selectedModel)
            }
        }, [onSubmit, selectedModel])

        return (
            <ModalPanel onClose={onClose} className="max-w-2xl w-full">
                <Title variant="heading2" weight="semibold">
                    Add new AI training template
                </Title>
                <ExclusiveChoiceDropdown
                    label="AI model"
                    placeholder="Choose an AI model"
                    choices={choices}
                    selectedIndex={selectedModelIndex}
                    onClick={setSelectedModelIndex}
                />

                <div className="flex justify-center pt-4">
                    <Button
                        className="w-auto"
                        disabled={isProcessing || handleSubmit === undefined}
                        onClick={handleSubmit}
                    >
                        {isProcessing ? "Adding..." : "Add"}
                    </Button>
                </div>
            </ModalPanel>
        )
    }
